<template>
    <b-overlay  rounded="sm">
        <div class="border-0 no-shadow">
            <common-list  :pageurl="this.$api_url"  is_action="0" checkbox="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" is_pf="1" v-on:childToParent="listReturn"></common-list>

        </div>
    </b-overlay>
</template>


<script>
    export default{
        props: ['pageurl','is_loan'],

        data(){
            return {

                cu:window.location.href,
                ce:false,
                employees : [],
                list_key: 0,
                primary_key: 'employee_id',
                company_options: [],
                appended_column: [],
                default_column: ['name', 'department', 'jobposition', 'branch'],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                search_group:{name:'', email:'', phone:'' },
                search_by_id:{department_id:0, jobposition_id:0 , branch_id:0 , status:0},



                showoverlay : true,

                notice: "Looks like you have not added any employee yet.",
                blankmsg : 'Fetching data..',
                people:0,

                depertments:[],
                jobtypes:[],
                branches:[],
                manager:[],
                leave_policies : [],
                pgurl:this.$api_url,

                search:'',
                length: 20,
                length_options: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                custom_list:[],  /* Data List */
                tmp_custom_list:[],
                custom_array:[],
            }
        },
        methods:{

            listReturn: function (data) {
                if (data.selected.length > 0) {
                    this.selected = data.selected;
                } else {
                    this.selected = [];
                    if (data.employee_id > 0) {
                    const employee = this.employees.find(emp => emp.employee_id === data.employee_id);
                    this.editEmployee(data.employee_id, 0);
                    }
                }
            },

            getEmployees: function(){
                let currentObj = this;
                this.showoverlay = true;
                this.show_loader = true;
                axios.get(this.$api_url+'/pf/loan/eligible-employee-list', {
                    params: {
                            pf_loan:1,
                        }
                        })
                .then(function (response) {
                    this.showoverlay = false;

                        /* Assingning the Options */

                        this.company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));

                        /* Assingning the list */
                        this.tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));

                        /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

                        if(this.tmp_custom_list.length > 0 )
                        {
                            this.tmp_custom_list.forEach(element => {
                                    if(element.employee_id > 0)
                                    {
                                        this.custom_array[element.employee_id] = element;
                                    }
                                });

                        }

                        this.custom_list = this.tmp_custom_list;
                        this.show_loader = false;
                        console.log(this.custom_list);
                        this.list_key = this.list_key + 1;
                }.bind(this)).catch(function (error){currentObj.showoverlay = false; currentObj.serverError(error);});
            },

            editEmployee:function(x,name)
            {
                this.showoverlay = true;
                if(!this.checkNet()) return false;

                let currentObj = this;
                let formData = new FormData();
                formData.append('employee_id', x);
                axios.post(this.$api_url+'/employee/setemployee', formData)
                    .then(function (response)
                    {   let data = [];
                        data['id'] = x;
                        data['name'] = name;

                        setTimeout(function () { this.$emit('childToParent' , data);
                        this.showoverlay = false;
                        }.bind(this), 1000);



                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });

            },
        },
        created: function(){
            this.getEmployees();

        },
    }
</script>